// Académies (IA) et Inspections de l'Éducation et de la Formation (IEF) du Sénégal.
// Liste indicative : la saisie libre reste possible si une IEF manque.
export const ACADEMIES = [
  { ia: "IA de Dakar", region: "Dakar", iefs: ["IEF Almadies", "IEF Dakar Plateau", "IEF Grand Dakar", "IEF Parcelles Assainies"] },
  { ia: "IA de Pikine-Guédiawaye", region: "Dakar", iefs: ["IEF Pikine", "IEF Thiaroye", "IEF Guédiawaye", "IEF Keur Massar"] },
  { ia: "IA de Rufisque", region: "Dakar", iefs: ["IEF Rufisque Commune", "IEF Rufisque Département", "IEF Diamniadio"] },
  { ia: "IA de Thiès", region: "Thiès", iefs: ["IEF Thiès Commune", "IEF Thiès Département", "IEF Mbour 1", "IEF Mbour 2", "IEF Tivaouane"] },
  { ia: "IA de Diourbel", region: "Diourbel", iefs: ["IEF Diourbel", "IEF Bambey", "IEF Mbacké"] },
  { ia: "IA de Fatick", region: "Fatick", iefs: ["IEF Fatick", "IEF Foundiougne", "IEF Gossas"] },
  { ia: "IA de Kaolack", region: "Kaolack", iefs: ["IEF Kaolack Commune", "IEF Kaolack Département", "IEF Nioro du Rip", "IEF Guinguinéo"] },
  { ia: "IA de Kaffrine", region: "Kaffrine", iefs: ["IEF Kaffrine", "IEF Birkelane", "IEF Koungheul", "IEF Malem Hodar"] },
  { ia: "IA de Kolda", region: "Kolda", iefs: ["IEF Kolda", "IEF Vélingara", "IEF Médina Yoro Foulah"] },
  { ia: "IA de Sédhiou", region: "Sédhiou", iefs: ["IEF Sédhiou", "IEF Bounkiling", "IEF Goudomp"] },
  { ia: "IA de Ziguinchor", region: "Ziguinchor", iefs: ["IEF Ziguinchor", "IEF Bignona 1", "IEF Bignona 2", "IEF Oussouye"] },
  { ia: "IA de Kédougou", region: "Kédougou", iefs: ["IEF Kédougou", "IEF Saraya", "IEF Salémata"] },
  { ia: "IA de Tambacounda", region: "Tambacounda", iefs: ["IEF Tambacounda", "IEF Bakel", "IEF Goudiry", "IEF Koumpentoum"] },
  { ia: "IA de Matam", region: "Matam", iefs: ["IEF Matam", "IEF Kanel", "IEF Ranérou"] },
  { ia: "IA de Saint-Louis", region: "Saint-Louis", iefs: ["IEF Saint-Louis Commune", "IEF Saint-Louis Département", "IEF Dagana", "IEF Podor"] },
  { ia: "IA de Louga", region: "Louga", iefs: ["IEF Louga", "IEF Kébémer", "IEF Linguère"] },
];

export const REGIONS = [
  "Dakar", "Diourbel", "Fatick", "Kaffrine", "Kaolack", "Kédougou", "Kolda",
  "Louga", "Matam", "Saint-Louis", "Sédhiou", "Tambacounda", "Thiès", "Ziguinchor",
];

export const ALL_IEFS = ACADEMIES.flatMap((a) => a.iefs);

export const iefsFor = (ia) => ACADEMIES.find((a) => a.ia === ia)?.iefs || ALL_IEFS;
export const regionFor = (ia) => ACADEMIES.find((a) => a.ia === ia)?.region;

export const SCHOOL_TYPES = [
  { value: "public", label: "Public" },
  { value: "prive", label: "Privé" },
  { value: "franco-arabe", label: "Franco-arabe" },
  { value: "communautaire", label: "Communautaire" },
  { value: "autre", label: "Autre" },
];

export const LEVELS = ["CI", "CP", "CE1", "CE2", "CM1", "CM2"];
